import { useI18n } from "react-simple-i18n";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";


import { heroImg } from "../../assets/image";
import { GlobalFirstSection, GlobalSpacing } from "../../components/layout/styles";
import { FirstButton, FirstOutlineButton } from "../../components/buttons/buttons";
import { useCustomNavigate } from "../../provider/navigate";
import { useGlobalContext } from "../../provider";

const Hero = () => {
	const { t } = useI18n();
	const { customNavigate } = useCustomNavigate();
	const [globalState]: GlobalContextType = useGlobalContext();

	return (
		<HeroWrapper>
			<HeroContainer>
				<HeroContent>
					<Typography variant="h1">
						{t("hero.title")}
					</Typography>

					<Typography variant="h6">
						{t("hero.description")}
					</Typography>

					<ButtonsWrapper>
						{!globalState.loginStatus && (
							<FirstButton onClick={customNavigate("/register")}>
								<Typography variant="h6">{t("hero.joinForFree")}</Typography>
							</FirstButton>
						)}

						<FirstOutlineButton onClick={customNavigate("/browseCourse")}>
							<Typography variant="h6">
								{t("hero.browseCourse")}
							</Typography>
						</FirstOutlineButton>
					</ButtonsWrapper>
				</HeroContent>

				<HeroImage>
					<img src={heroImg} alt="hero" />
				</HeroImage>
			</HeroContainer>
		</HeroWrapper>
	)
}

const HeroWrapper = styled(GlobalFirstSection)(({ theme }) => ({
	// background: `url(${heroBgImg})`,
	// backgroundSize: "100% 100%",
	// backgroundRepeat: "no-repeat",

	display: "flex",
	flexDirection: "column",
	padding: "50px 0px",
}))

const HeroContainer = styled(GlobalSpacing)(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: theme.spacing(3),

	[theme.breakpoints.down("lg")]: {
		flexDirection: "column-reverse",
		justifyContent: "space-evenly",
	},

	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
	}
}))

const HeroContent = styled(Box)(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "column",
	gap: theme.spacing(8),

	h6: {
		fontWeight: 400,
	},

	[theme.breakpoints.down("lg")]: {
		maxWidth: 650,
		gap: theme.spacing(5),
		alignItems: "center",
		textAlign: "center",
	},

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(3),
		justifyContent: "space-evenly",
	}
}))

const HeroImage = styled(Box)(({ theme }) => ({
	flex: 1,
	display: "flex",
	justifyContent: "center",

	img: {
		width: "100%",
		maxWidth: "500px",
		aspectRatio: "1/1",
	},

	[theme.breakpoints.down("lg")]: {
		width: "100%",

		img: {
			maxWidth: "400px",
		}
	}
}))

const ButtonsWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: theme.spacing(3),
	maxWidth: 400,
	width: "100%",

	button: {
		flex: 1,
	},

	[theme.breakpoints.down("lg")]: {
		gap: theme.spacing(2),
	}
}))

export { Hero };